const styles = {
  root: {
    background: '#FAFAFF',
    minHeight: '100vh',
    fontSize: 16,
  },
};

export default styles;
